import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import WorekrHeader from "../../worker-header/components/index";
import WorkerFooter from "../../worker-footer/components/index";
import { login, saveTokenInLocalStorage, getToken } from "../slice/workerAuthSlice";
import { getInfo } from "../../worker-panel/slice/workerInfoSlice";
import { GoogleLogin } from '@react-oauth/google';

const WorkerSignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    device_name: "test"
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/panel"); // or wherever
    }
  }, []);

  useEffect(() => {
    dispatch(getToken());
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    setLoading(true);

    // const { email, password } = formData;
    // const rememberMe = document.getElementById("rememberMe").checked;

    const result = await dispatch(login(formData));

    if (result.meta.requestStatus === "fulfilled") {
      const { token: access_token, user } = result.payload.data;
      const token = access_token.split("|")[1];

      saveTokenInLocalStorage(token);
      localStorage.setItem("user_id", JSON.stringify(user.id));

      // localStorage.setItem("user_data", JSON.stringify(user));

      // Set or remove cookie based on rememberMe
      // if (rememberMe) {
      //   Cookies.set("c_email", email, { expires: 30 }); // 30 days
      //   Cookies.set("c_password", password, { expires: 30 }); // 30 days
      // } else {
      //   Cookies.remove("c_email");
      //   Cookies.remove("c_password");
      // }

      toast.success("Login successful!", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });

      navigate("/panel");
    } else {
      toast.error("Login failed. Please check your credentials.", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
    setLoading(false);
  };

  //  useEffect(() => {
  //   const savedEmail = Cookies.get("c_email");
  //   const savedPassword = Cookies.get("c_password");

  //   if (savedEmail && savedPassword) {
  //     setFormData({
  //       email: savedEmail,
  //       password: savedPassword,
  //     });

  //     const checkbox = document.getElementById("rememberMe");
  //     if (checkbox) checkbox.checked = true;
  //   }
  // }, []);



  return (

    <>
      <WorekrHeader />
      <main className="overflow-hidden">
        <section className="homepad-signin">
          <div className="container">
            <div className="row">
              {/* 👶 Register Section */}
              <div className="col-md-6 left-panel-signin"
                style={{
                  backgroundImage: "url('/assets/images/login-left-3.png')",
                  backgroundRepeat: "no-repeat"
                }}>
                <div className="left-overlay-signin">
                  <h2 className="montserrat font-weight-bold lh-1 font-size-60">Welcome, <span className="text-yellow">Providers</span> & <span className="text-yellow">Workers</span></h2>
                  <div className="">
                    <p className="m-0 font-size-14 lh-base">Log in to access your National Childcare Alliance Foundation account. From your dashboard you can manage your provider profile, explore workforce stability resources, connect with trusted benefits partners, and navigate state childcare compliance tools designed to support your program.<br />
                      🔵 The NCAF platform is dedicated to strengthening the childcare workforce by helping providers access the tools, resources, and partnerships needed to build stable, thriving childcare programs.</p>
                  </div>
                </div>
              </div>

              {/* 🔐 Login Section */}
              <div className="col-md-6 bg-white d-flex align-items-center">
                <div className="login-form w-100">
                  <div className="logo text-center mb-4">
                    <img src="/assets/images/NCAF_Logo.png" style={{ width: "200px !important", height: "100px" }} />
                  </div>
                  <h3 className="font-weight-bold montserrat text-primary font-size-38 mb-3 lh-1 text-center">Welcome back</h3>
                  <p className="text-center text-dark">Access Your NCAF Provider Dashboard</p>

                  <form className="mt-3 mt-xl-4 pt-xl-2 d-block" onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label text-primary mb-1 font-weight-semibold">Email Address</label>
                      <input
                        type="text"
                        name="email"
                        className="form-control"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label text-primary mb-1 font-weight-semibold">Password</label>
                      <input
                        type="password"
                        name="password"
                        className="form-control"
                        placeholder="Enter your password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="text-primary font-weight-semibold">
                              <input type="checkbox" id="rememberMe" className="me-1" />
                              <label htmlFor="rememberMe">  Remember Password</label>
                            </div>
                            <a href="/forgot-password" className="text-decoration-none text-primary font-weight-semibold"><u>Forgot Password?</u></a>
                          </div> */}
                    <div className="pt-2 pt-xl-3">
                      <button
                        type="submit"
                        className="btn btn-light-header w-100 mb-3 font-weight-bold font-size-18 text-light"
                        disabled={loading}
                      >
                        {loading ? (
                          <span className="d-flex align-items-center justify-content-center">
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Signing in...
                          </span>
                        ) : (
                          <span className="d-block py-1">Log In to Dashboard</span>
                        )}
                      </button>

                      <div className="text-center mb-3">
                        <h6 className="font-weight-semibold mb-1">🔒 Secure Access</h6>
                        <p className="text-muted font-size-14 mb-0">
                          Your information is protected using secure encryption and industry-standard
                          data protection practices.
                        </p>
                      </div>

                    </div>
                    <div className="text-center">

                      <div className="mb-3">
                        <a
                          href="/forgot-password"
                          className="text-decoration-none text-primary font-weight-semibold"
                        >
                          <u>Forgot Password?</u>
                        </a>
                        <p className="mb-0 mt-1 font-size-14 text-muted">
                          Reset your password securely.
                        </p>
                      </div>

                      <div>
                        <Link
                          to="https://dev.4ncaf.org/employer-register-2/"
                          className="text-decoration-none text-primary font-weight-semibold"
                        >
                          <u>New to NCAF?</u>
                        </Link>
                        <p className="mb-0 mt-1 font-size-14 text-muted">
                          Create your provider account to access workforce resources, benefits
                          partners, and compliance guidance.
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <WorkerFooter />
      </main>
    </>
  );
};

export default WorkerSignIn;
